<template>
	<div class="character holly">
		<div class="strings"></div>
		<div class="bg-cork"></div>
		<div class="post-mark"></div>
		<router-link @click="toTop" to="/" class="desktop-keys">
			<div class="keys"></div>
		</router-link>

		<cc />
		<div class="vertical-string">
			<div class="media-wrapper">
				<div class="ch-photo"></div>

				<div class="player-wrapper" :class="{ 'disabled': audioUrl.length === 0 }">
					<AudioPlayer id="player1" :file="audioUrl" class="player"></AudioPlayer>
					<div class="label"><span>{{ lang('listen') }}</span></div>
				</div>

				<VDropdown :distance="-20" strategy="fixed" @show="popperShowHandler('read-more')" @hide="popperHideHandler('read-more')">
					<!-- This will be the popover target (for the events and position) -->
					<div class="read-icon-wrapper"
						:class="{ 'disabled': readMore.length === 0, 'animate': readMore.length > 0 }">
						<div class="read-icon-1"></div>
						<div class="read-icon-2"></div>
						<div class="read-icon-3"></div>
						<div class="label"><span>{{ lang('read') }}</span></div>
					</div>
					<!-- This will be the content of the popover -->

					<template #popper>
						<div class="read-popper">
							<a class="popper-closer" v-close-popper><i class="fas fa-times-circle"></i></a>
							<ReadMore :popper-open="vPopperOpen" :key="refreshReadMore" />
						</div>
					</template>
				</VDropdown>

				<VDropdown :distance="-20" strategy="fixed" @show="popperShowHandler('evidence')" @hide="popperHideHandler('evidence')">
					<div class="evidence-icon"
						:class="{ 'empty-evidence': $evidence.value === null, 'animate': $evidence.value !== null }">
						<div class="label"><span>{{ lang('evidence') }}</span></div>
					</div>

					<!-- This will be the content of the popover -->
					<template #popper>
						<div class="evidence-popper">
							<a class="popper-closer" v-close-popper><i class="fas fa-times-circle"></i></a>
							<evidence />
						</div>
					</template>
				</VDropdown>

			</div>
		</div>

		<!-- CONTENT SCROLL -->
		<div class="character-d" scroll="no">
			<div class="slides">
				<TopTextBox :items="textBoxData" />

				<!-- composition -->
				<div class="composition zoom">
					<img src="/themes/rise-theme/dist/images/estate/character-view/holly/09_House.png" alt="">

					<start1 />
					<painting2 />
					<painting3 />
					<painting4 />
					<painting5 />
					<painting6 />
					<key7 />
					<house8 />
					<photo9 />
					<photo10 />
					<photo11 />
					<photo12 />
					<hand13 />
					<hand14 />
					<sheet15 />
					<hand16 />
					<sleepingarea17 />
					<screen18 />
					<action19 />
					<map20 />
					<social21 />
					<plane22 />
					<house23 />
					<circle24 />
					<circle25 />
					<finish26 />
					<finish27 />
				</div>
				<!-- // composition -->
			</div>

			<ControlsButton class="holly-controls-button" :data="controlsButtonData" />
			<cc-control></cc-control>
			<langControl/>
			<black_overlay id="black_overlay" :overlay="overlay" />
			<outro id="outro" :outro="outro" />

		</div>
		<!-- // CONTENT SCROLL -->
		<audio class="invisible" src="/themes/rise-theme/resources/assets/audio/holly/1.mp3" preload="auto"></audio>
		<audio class="invisible" src="/themes/rise-theme/resources/assets/audio/holly/2.mp3" preload="auto"></audio>
		<audio class="invisible" src="/themes/rise-theme/resources/assets/audio/holly/3.mp3" preload="auto"></audio>
		<audio class="invisible" src="/themes/rise-theme/resources/assets/audio/holly/4.mp3" preload="auto"></audio>
		<audio class="invisible" src="/themes/rise-theme/resources/assets/audio/holly/5.mp3" preload="auto"></audio>

	</div>
</template>

<script>
import start1 from './holly/start-1.vue';
import painting2 from './holly/painting-2.vue';
import painting3 from './holly/painting-3.vue';
import painting4 from './holly/painting-4.vue';
import painting5 from './holly/painting-5.vue';
import painting6 from './holly/painting-6.vue';
import key7 from './holly/key-7.vue';
import house8 from './holly/house-8.vue';
import photo9 from './holly/photo-9.vue';
import photo10 from './holly/photo-10.vue';
import photo11 from './holly/photo-11.vue';
import photo12 from './holly/photo-12.vue';
import hand13 from './holly/hand-13.vue';
import hand14 from './holly/hand-14.vue';
import sheet15 from './holly/sheet-15.vue';
import hand16 from './holly/hand-16.vue';
import sleepingarea17 from './holly/sleepingarea-17.vue';
import screen18 from './holly/screen-18.vue';
import action19 from './holly/action-19.vue';
import map20 from './holly/map-20.vue';
import social21 from './holly/social-21.vue';
import plane22 from './holly/plane-22.vue';
import house23 from './holly/house-23.vue';
import circle24 from './holly/circle-24.vue';
import circle25 from './holly/circle-25.vue';
import finish26 from './holly/finish-26.vue';
import finish27 from './holly/finish-27.vue';

import TopTextBox from '../components/TopTextBox';
import textBoxData from './holly/text-box';

import outro from './outro.vue';
import black_overlay from './black_overlay.vue';
import AudioPlayer from '../../components/audioPlayer.vue';
import ControlsButton from '../../components/controlsButton';
import controlsButtonData from './holly/controlsButtonData';
import evidence from '../components/evidence.vue';
import ReadMore from '../components/ReadMore.vue';
import cc from '../../components/cc.vue'
import cc_control from '../../components/cc_control.vue'
import langControl from '../../components/langControl.vue'

export default {
	name: 'holly',
	inject: ['helpers', 'lang'],
	components: {
		TopTextBox,
		AudioPlayer,
		ControlsButton,
		ReadMore,
		outro,
		black_overlay,
		evidence,
		cc,
		'cc-control': cc_control,
		langControl,

		start1,
		painting2,
		painting3,
		painting4,
		painting5,
		painting6,
		key7,
		house8,
		photo9,
		photo10,
		photo11,
		photo12,
		hand13,
		hand14,
		sheet15,
		hand16,
		sleepingarea17,
		screen18,
		action19,
		map20,
		social21,
		plane22,
		house23,
		circle24,
		circle25,
		finish26,
		finish27
	},
	data() {
		return {
			controlsButtonData,
			textBoxData,
			showModal: false,
			audioUrl: '',
			vPopperOpen: false,
			readMore: '',
			refreshReadMore: 0,

			outro: [
				{
					start: 25700,
					end: 26500,
					fromStyle: { bottom: '-150%', opacity: 0.8 },
					toStyle: { bottom: '0%', opacity: 1 }
				}
			],

			overlay: [
				{
					start: 25700,
					end: 26500,
					fromStyle: { opacity: '0' },
					toStyle: { opacity: '0.9' },
					easing: 'linear'
				}
			]

		}
	},
	created() {
		this.$watch('$audioUrl.value', (newVal) => {
			this.setAudioUrl(newVal);
		}, { immediate: true });

		this.$watch('$readMore.value', (newVal) => {
			this.setReadMore(newVal);
		}, { immediate: true });
	},
	mounted() {
		window.document.querySelector('html').scrollTo({
			top: 0,
			behavior: "smooth"
		});
	},
	methods: {
		setAudioUrl(value) {
			this.audioUrl = value;
		},
		setReadMore(value) {
			this.readMore = value;
			if (!this.readMore.length) {
				// close popper if read more is empty automatically
			}
		},
		popperShowHandler(type) {
			setTimeout(() => {
				if (document.querySelector('.v-popper__popper--shown') != null) {
					document.querySelector('.v-popper__popper--shown').classList.add(type);
				}
			}, 500);
			this.refreshReadMore += 1;
			this.vPopperOpen = true;
		},
		popperHideHandler() {
			const self = this;
			setTimeout(() => {
				if (document.querySelector('.v-popper__popper--shown') != null) {
					document.querySelector('.v-popper__popper--shown').classList.remove('evidence');
				}

				if (document.querySelector('.v-popper__popper--shown') != null) {
					document.querySelector('.v-popper__popper--shown').classList.remove('read-more');
				}

				self.vPopperOpen = false;
			}, 500);
		},
		toTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		}
	},

}
</script>

<style lang="scss" scoped>
html {
	-ms-overflow-style: none;
	/* IE and Edge */
	scrollbar-width: none;

	/* Firefox */
	&::-webkit-scrollbar {
		display: none;
	}
}

@media(max-width: 400px) {
	.holly .comment-box {
		top: 18%;
	}
}
.holly-controls-button {
	bottom: 59px;
}
.character {
	&.holly {
		.next-button {
			right: 5%;
			left: initial;

			@media(min-width: 1025px) {
				right: -1%;
			}

			@media(min-width: 1100px) {
				right: 2%;
			}

			@media(min-width: 1200px) {
				right: 5%;
			}

			@media(min-width: 1200px) {
				right: 7%;
			}

			@media(min-width: 1400px) {
				right: 9%;
			}

			@media(min-width: 1700px) {
				right: 10%;
			}

			@media(min-width: 1800px) {
				right: 12%;
			}

			@media(min-width: 1800px) {
				right: 14%;
			}
		}

		img {
			max-width: 100%;
			width: auto;
		}

		.ch-photo {
			background-image: url('/themes/rise-theme/dist/images/estate/character-view/characters/Holly@2x.png') !important;
		}

		.post-mark {
			background-image: url("/themes/rise-theme/dist/images/estate/character-view/post-mark-3.png");

			@media(max-width: 600px) {
				display: none;
			}

		}
	}

}

.composition {
	position: fixed;
	top: calc(50% - 320px);
	left: calc(50% - 380px);
	max-width: 950px;
	width: 100%;

	&>img:first-child {
		visibility: hidden;
	}

	.house-1 {
		position: absolute;
		top: 0;
		left: 0;
		z-index: -3;
		max-width: 950px;
		width: 100%;
		transition: all 0.1s linear;
	}
}

.slides {
	position: fixed;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	z-index: 5;
}

.comment-box {
	opacity: 0;
}

@media screen and (max-width: 1600px) {
	.composition {
		top: calc(50% - 250px);
		left: calc(50% - 300px);
		max-width: 750px;
	}
}

@media(min-width: 600px) and (max-width: 1280px) {
	.composition {
		zoom: 0.8;
	}
}

@media screen and (max-width: 1024px) {
	.composition {
		top: calc(50% - 250px);
		left: calc(50% - 335px);
		max-width: 700px;
	}
}

@media screen and (max-width: 650px) {
	.comment-box br {
		display: none;
	}

	.composition {
		top: calc(50% - 120px);
		left: calc(50% - 184px);
		max-width: 370px;
	}
}

@media(max-width: 400px) {
	.composition {
		left: calc(50% - 160px);
		top: calc(50% - 90px);
	}
}

@media screen and (max-width: 991px) and (orientation: landscape) {
	.character-d .zoom {zoom: 0.5 !important;}
}
</style>
